import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

/**
 * Creates an activity-log row on the backend (e.g. VIEW_PROJECT when a user opens
 * a project). The server validates the action, looks up the project's business_id,
 * and stamps the acting user — so the client only sends the action + project.
 */
export const postActivityLog = async ({
  projectId,
  action,
  targetType,
  targetId,
  targetName,
  metadata,
  activeEmployerInfo = {},
  isLocalApiRequest = false,
}) => {
  const apiPath = `activity-log/project/${projectId}`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: { action, targetType, targetId, targetName, metadata },
    activeEmployerInfo,
    isLocalApiRequest,
  });

  const response = await axios(signedRequest);

  return response.data;
};
